/**
 * Shared in-memory logout flag.
 *
 * Prevents a race condition where a concurrent token refresh could write
 * a new token back to localStorage after forceLogout has cleared it.
 *
 * Separated from auth.js to avoid circular-dependency issues
 * (apiClient imports this, auth.js imports apiClient indirectly).
 */

let _isLoggingOut = false;

export function markLoggingOut() {
  _isLoggingOut = true;
}

export function isLoggingOut() {
  return _isLoggingOut;
}

export function resetLoggingOut() {
  _isLoggingOut = false;
}
